import { useState } from 'react';
import '../stylesheets/Menus.css';

export default function CreateGameMenu({ onCreateGame, onCancel }) {
    // classic User Inputs
    const [playerName, setPlayerName] = useState('');
    // there has to be a default number of squares, 30 is the one currently used as example 
    const [numberOfSquares, setNumberOfSquares] = useState(30);

    const handleSubmit = (e) => {
        e.preventDefault(); // Avoid page reload
        
        // Check if name is empty
        if (!playerName.trim()) {
            alert('Please enter your name');
            return;
        }

        // Validate number of squares, is between 10 and 100
        if (numberOfSquares < 10 || numberOfSquares > 100) {
            alert('Number of squares must be between 10 and 100');
            return;
        }

        // Call onCreateGame with the form data
        onCreateGame({
            name: playerName.trim(),
            numberOfSquares: numberOfSquares
        });
    };

    return (
        <div className="create-game-menu-container">
            <h2 className="create-game-title">Create New Game</h2>
            
            <form onSubmit={handleSubmit} className="create-game-form">
                {/* Space to fill the name */}
                <div className="form-group">
                    <label htmlFor="playerName" className="form-label">
                        Your Name:
                    </label>
                    <input
                        type="text"
                        id="playerName"
                        value={playerName}
                        onChange={(e) => setPlayerName(e.target.value)}
                        placeholder="Enter your name"
                        className="form-input"
                        required
                    />
                </div>

                {/* Space to choose the number of squares*/}
                <div className="form-group">
                    <label htmlFor="numberOfSquares" className="form-label">
                        Number of Squares:
                    </label>
                    <input
                        type="number"
                        id="numberOfSquares"
                        value={numberOfSquares}
                        onChange={(e) => setNumberOfSquares(parseInt(e.target.value) || 30)}
                        min="10"
                        max="100"
                        className="form-input"
                        required
                    />
                </div>

                {/* Buttons */}
                <div className="form-buttons">
                    {/* our cancel button to cancel the creation of the game */}
                    <button type="button" onClick={onCancel} className="cancel-button">
                        Cancel
                    </button>
                    
                    <button type="submit" className="create-game-button">
                        Create Game
                    </button>

                </div>
            </form>
        </div>
    );
}